import {
  Core as CoreFallback,
  Action as ActionFallback,
  Message as MessageFallback,
  Expressive as ExpressiveFallback,
  Program as ProgramFallback,
  Button as ButtonFallback,
  Tag as TagFallback,
  Toggle as ToggleFallback,
  ProgressBar as ProgressBarFallback,
} from "./__internal__/semantic-fallback";

export const Core = {
  surface: {
    primary: `var(--slate-color-surface-primary, ${CoreFallback.surface.primary})`,
    primaryInverse: `var(--slate-color-surface-primary-inverse, ${CoreFallback.surface.primaryInverse})`,
    secondary: `var(--slate-color-surface-secondary, ${CoreFallback.surface.secondary})`,
    tertiary: `var(--slate-color-surface-tertiary, ${CoreFallback.surface.tertiary})`,
    overlay: `var(--slate-color-surface-overlay, ${CoreFallback.surface.overlay})`,
    mask: `var(--slate-color-surface-mask, ${CoreFallback.surface.mask})`,
    neutral: `var(--slate-color-surface-neutral, ${CoreFallback.surface.neutral})`,
    transparent: `var(--slate-color-surface-transparent, ${CoreFallback.surface.transparent})`,
  },
  border: {
    subdued: `var(--slate-color-border-subdued, ${CoreFallback.border.subdued})`,
    muted: `var(--slate-color-border-muted, ${CoreFallback.border.muted})`,
  },
  text: {
    primary: `var(--slate-color-text-primary, ${CoreFallback.text.primary})`,
    subdued: `var(--slate-color-text-subdued, ${CoreFallback.text.subdued})`,
    primaryInverse: `var(--slate-color-text-primary-inverse, ${CoreFallback.text.primaryInverse})`,
    accent: `var(--slate-color-text-accent, ${CoreFallback.text.accent})`,
  },
  icon: {
    primary: `var(--slate-color-icon-primary, ${CoreFallback.icon.primary})`,
    subdued: `var(--slate-color-icon-subdued, ${CoreFallback.icon.subdued})`,
    primaryInverse: `var(--slate-color-icon-primary-inverse, ${CoreFallback.icon.primaryInverse})`,
  },
} as const;

export const Action = {
  surface: {
    default: `var(--slate-color-action-surface-default, ${ActionFallback.surface.default})`,
    inverse: `var(--slate-color-action-surface-inverse, ${ActionFallback.surface.inverse})`,
    hover: `var(--slate-color-action-surface-hover, ${ActionFallback.surface.hover})`,
    inverseHover: `var(--slate-color-action-surface-inverse-hover, ${ActionFallback.surface.inverseHover})`,
    inverseActive: `var(--slate-color-action-surface-inverse-active, ${ActionFallback.surface.inverseActive})`,
    active: `var(--slate-color-action-surface-active, ${ActionFallback.surface.active})`,
    disabled: `var(--slate-color-action-surface-disabled, ${ActionFallback.surface.disabled})`,
    neutral: `var(--slate-color-action-surface-neutral, ${ActionFallback.surface.neutral})`,
    neutralHover: `var(--slate-color-action-surface-neutral-hover, ${ActionFallback.surface.neutralHover})`,
    neutralActive: `var(--slate-color-action-surface-neutral-active, ${ActionFallback.surface.neutralActive})`,
    favorited: `var(--slate-color-action-surface-favorited, ${ActionFallback.surface.favorited})`,
    critical: `var(--slate-color-action-surface-critical, ${ActionFallback.surface.critical})`,
    criticalHover: `var(--slate-color-action-surface-critical-hover, ${ActionFallback.surface.criticalHover})`,
    criticalInverseHover: `var(--slate-color-action-surface-critical-inverse-hover, ${ActionFallback.surface.criticalInverseHover})`,
    criticalActive: `var(--slate-color-action-surface-critical-active, ${ActionFallback.surface.criticalActive})`,
    criticalInverseActive: `var(--slate-color-action-surface-critical-inverse-active, ${ActionFallback.surface.criticalInverseActive})`,
  },
  border: {
    default: `var(--slate-color-action-border-default, ${ActionFallback.border.default})`,
    inverse: `var(--slate-color-action-border-inverse, ${ActionFallback.border.inverse})`,
    subdued: `var(--slate-color-action-border-subdued, ${ActionFallback.border.subdued})`,
    hover: `var(--slate-color-action-border-hover, ${ActionFallback.border.hover})`,
    active: `var(--slate-color-action-border-active, ${ActionFallback.border.active})`,
    disabled: `var(--slate-color-action-border-disabled, ${ActionFallback.border.disabled})`,
    focus_ring: `var(--slate-color-action-border-focus_ring, ${ActionFallback.border.focus_ring})`,
    critical: `var(--slate-color-action-border-critical, ${ActionFallback.border.critical})`,
  },
  text: {
    default: `var(--slate-color-action-text-default, ${ActionFallback.text.default})`,
    inverse: `var(--slate-color-action-text-inverse, ${ActionFallback.text.inverse})`,
    hover: `var(--slate-color-action-text-hover, ${ActionFallback.text.hover})`,
    inverseHover: `var(--slate-color-action-text-inverse-hover, ${ActionFallback.text.inverseHover})`,
    active: `var(--slate-color-action-text-active, ${ActionFallback.text.active})`,
    inverseActive: `var(--slate-color-action-text-inverse-active, ${ActionFallback.text.inverseActive})`,
    disabled: `var(--slate-color-action-text-disabled, ${ActionFallback.text.disabled})`,
    placeholder: `var(--slate-color-action-text-placeholder, ${ActionFallback.text.placeholder})`,
    critical: `var(--slate-color-action-text-critical, ${ActionFallback.text.critical})`,
    criticalHover: `var(--slate-color-action-text-critical-hover, ${ActionFallback.text.criticalHover})`,
    criticalInverse: `var(--slate-color-action-text-critical-inverse, ${ActionFallback.text.criticalInverse})`,
    criticalActive: `var(--slate-color-action-text-critical-active, ${ActionFallback.text.criticalActive})`,
  },
  icon: {
    default: `var(--slate-color-action-icon-default, ${ActionFallback.icon.default})`,
    inverse: `var(--slate-color-action-icon-inverse, ${ActionFallback.icon.inverse})`,
    hover: `var(--slate-color-action-icon-hover, ${ActionFallback.icon.hover})`,
    inverseHover: `var(--slate-color-action-icon-inverse-hover, ${ActionFallback.icon.inverseHover})`,
    active: `var(--slate-color-action-icon-active, ${ActionFallback.icon.active})`,
    inverseActive: `var(--slate-color-action-icon-inverse-active, ${ActionFallback.icon.inverseActive})`,
    disabled: `var(--slate-color-action-icon-disabled, ${ActionFallback.icon.disabled})`,
    critical: `var(--slate-color-action-icon-critical, ${ActionFallback.icon.critical})`,
    criticalHover: `var(--slate-color-action-icon-critical-hover, ${ActionFallback.icon.criticalHover})`,
    criticalInverse: `var(--slate-color-action-icon-critical-inverse, ${ActionFallback.icon.criticalInverse})`,
    criticalActive: `var(--slate-color-action-icon-critical-active, ${ActionFallback.icon.criticalActive})`,
  },
} as const;

export const Message = {
  text: {
    critical: `var(--slate-color-message-text-critical, ${MessageFallback.text.critical})`,
    sale: `var(--slate-color-message-text-sale, ${MessageFallback.text.sale})`,
  },
  icon: {
    success: `var(--slate-color-message-icon-success, ${MessageFallback.icon.success})`,
    warning: `var(--slate-color-message-icon-warning, ${MessageFallback.icon.warning})`,
    critical: `var(--slate-color-message-icon-critical, ${MessageFallback.icon.critical})`,
    info: `var(--slate-color-message-icon-info, ${MessageFallback.icon.info})`,
  },
  border: {
    success: `var(--slate-color-message-border-success, ${MessageFallback.border.success})`,
    warning: `var(--slate-color-message-border-warning, ${MessageFallback.border.warning})`,
    critical: `var(--slate-color-message-border-critical, ${MessageFallback.border.critical})`,
    info: `var(--slate-color-message-border-info, ${MessageFallback.border.info})`,
  },
  surface: {
    success: `var(--slate-color-message-surface-success, ${MessageFallback.surface.success})`,
    warning: `var(--slate-color-message-surface-warning, ${MessageFallback.surface.warning})`,
    critical: `var(--slate-color-message-surface-critical, ${MessageFallback.surface.critical})`,
    info: `var(--slate-color-message-surface-info, ${MessageFallback.surface.info})`,
  },
} as const;

export const Expressive = {
  surface: {
    neutral: `var(--slate-color-expressive-surface-neutral, ${ExpressiveFallback.surface.neutral})`,
    neutralInverse: `var(--slate-color-expressive-surface-neutral-inverse, ${ExpressiveFallback.surface.neutralInverse})`,
    yellow: `var(--slate-color-expressive-surface-yellow, ${ExpressiveFallback.surface.yellow})`,
    yellowInverse: `var(--slate-color-expressive-surface-yellow-inverse, ${ExpressiveFallback.surface.yellowInverse})`,
    green: `var(--slate-color-expressive-surface-green, ${ExpressiveFallback.surface.green})`,
    greenInverse: `var(--slate-color-expressive-surface-green-inverse, ${ExpressiveFallback.surface.greenInverse})`,
    blue: `var(--slate-color-expressive-surface-blue, ${ExpressiveFallback.surface.blue})`,
    blueInverse: `var(--slate-color-expressive-surface-blue-inverse, ${ExpressiveFallback.surface.blueInverse})`,
    red: `var(--slate-color-expressive-surface-red, ${ExpressiveFallback.surface.red})`,
    redInverse: `var(--slate-color-expressive-surface-red-inverse, ${ExpressiveFallback.surface.redInverse})`,
    orange: `var(--slate-color-expressive-surface-orange, ${ExpressiveFallback.surface.orange})`,
    orangeInverse: `var(--slate-color-expressive-surface-orange-inverse, ${ExpressiveFallback.surface.orangeInverse})`,
    olive: `var(--slate-color-expressive-surface-olive, ${ExpressiveFallback.surface.olive})`,
    eggplant: `var(--slate-color-expressive-surface-eggplant, ${ExpressiveFallback.surface.eggplant})`,
    earth: `var(--slate-color-expressive-surface-earth, ${ExpressiveFallback.surface.earth})`,
  },
  icon: {
    neutral: `var(--slate-color-expressive-icon-neutral, ${ExpressiveFallback.icon.neutral})`,
    neutralInverse: `var(--slate-color-expressive-icon-neutral-inverse, ${ExpressiveFallback.icon.neutralInverse})`,
    yellow: `var(--slate-color-expressive-icon-yellow, ${ExpressiveFallback.icon.yellow})`,
    yellowInverse: `var(--slate-color-expressive-icon-yellow-inverse, ${ExpressiveFallback.icon.yellowInverse})`,
    green: `var(--slate-color-expressive-icon-green, ${ExpressiveFallback.icon.green})`,
    greenInverse: `var(--slate-color-expressive-icon-green-inverse, ${ExpressiveFallback.icon.greenInverse})`,
    blue: `var(--slate-color-expressive-icon-blue, ${ExpressiveFallback.icon.blue})`,
    blueInverse: `var(--slate-color-expressive-icon-blue-inverse, ${ExpressiveFallback.icon.blueInverse})`,
    red: `var(--slate-color-expressive-icon-red, ${ExpressiveFallback.icon.red})`,
    redInverse: `var(--slate-color-expressive-icon-red-inverse, ${ExpressiveFallback.icon.redInverse})`,
    orange: `var(--slate-color-expressive-icon-orange, ${ExpressiveFallback.icon.orange})`,
    orangeInverse: `var(--slate-color-expressive-icon-orange-inverse, ${ExpressiveFallback.icon.orangeInverse})`,
  },
  text: {
    neutral: `var(--slate-color-expressive-text-neutral, ${ExpressiveFallback.text.neutral})`,
    neutralInverse: `var(--slate-color-expressive-text-neutral-inverse, ${ExpressiveFallback.text.neutralInverse})`,
    yellow: `var(--slate-color-expressive-text-yellow, ${ExpressiveFallback.text.yellow})`,
    yellowInverse: `var(--slate-color-expressive-text-yellow-inverse, ${ExpressiveFallback.text.yellowInverse})`,
    green: `var(--slate-color-expressive-text-green, ${ExpressiveFallback.text.green})`,
    greenInverse: `var(--slate-color-expressive-text-green-inverse, ${ExpressiveFallback.text.greenInverse})`,
    blue: `var(--slate-color-expressive-text-blue, ${ExpressiveFallback.text.blue})`,
    blueInverse: `var(--slate-color-expressive-text-blue-inverse, ${ExpressiveFallback.text.blueInverse})`,
    red: `var(--slate-color-expressive-text-red, ${ExpressiveFallback.text.red})`,
    redInverse: `var(--slate-color-expressive-text-red-inverse, ${ExpressiveFallback.text.redInverse})`,
    orange: `var(--slate-color-expressive-text-orange, ${ExpressiveFallback.text.orange})`,
    orangeInverse: `var(--slate-color-expressive-text-orange-inverse, ${ExpressiveFallback.text.orangeInverse})`,
  },
} as const;

export const Program = {
  surface: {
    insider: {
      primary: `var(--slate-color-program-surface-insider-primary, ${ProgramFallback.surface.insider.primary})`,
      primaryInverse: `var(--slate-color-program-surface-insider-primary-inverse, ${ProgramFallback.surface.insider.primaryInverse})`,
    },
    top_shop: {
      primary: `var(--slate-color-program-surface-top_shop-primary, ${ProgramFallback.surface.top_shop.primary})`,
      primaryInverse: `var(--slate-color-program-surface-top_shop-primary-inverse, ${ProgramFallback.surface.top_shop.primaryInverse})`,
      secondary: `var(--slate-color-program-surface-top_shop-secondary, ${ProgramFallback.surface.top_shop.secondary})`,
    },
    faire_source: {
      primary: `var(--slate-color-program-surface-faire_source-primary, ${ProgramFallback.surface.faire_source.primary})`,
      primaryInverse: `var(--slate-color-program-surface-faire_source-primary-inverse, ${ProgramFallback.surface.faire_source.primaryInverse})`,
    },
    faire_pay: {
      primary: `var(--slate-color-program-surface-faire_pay-primary, ${ProgramFallback.surface.faire_pay.primary})`,
      primaryInverse: `var(--slate-color-program-surface-faire_pay-primary-inverse, ${ProgramFallback.surface.faire_pay.primaryInverse})`,
      secondary: `var(--slate-color-program-surface-faire_pay-secondary, ${ProgramFallback.surface.faire_pay.secondary})`,
    },
    ai_suggestions: {
      primary: `var(--slate-color-program-surface-ai_suggestions-primary, ${ProgramFallback.surface.ai_suggestions.primary})`,
      primaryInverse: `var(--slate-color-program-surface-ai_suggestions-primary-inverse, ${ProgramFallback.surface.ai_suggestions.primaryInverse})`,
    },
    market: {
      primary: `var(--slate-color-program-surface-market-primary, ${ProgramFallback.surface.market.primary})`,
      primaryInverse: `var(--slate-color-program-surface-market-primary-inverse, ${ProgramFallback.surface.market.primaryInverse})`,
      secondary: `var(--slate-color-program-surface-market-secondary, ${ProgramFallback.surface.market.secondary})`,
      tertiary: `var(--slate-color-program-surface-market-tertiary, ${ProgramFallback.surface.market.tertiary})`,
    },
    faire_direct: {
      primary: `var(--slate-color-program-surface-faire_direct-primary, ${ProgramFallback.surface.faire_direct.primary})`,
      primaryInverse: `var(--slate-color-program-surface-faire_direct-primary-inverse, ${ProgramFallback.surface.faire_direct.primaryInverse})`,
      secondary: `var(--slate-color-program-surface-faire_direct-secondary, ${ProgramFallback.surface.faire_direct.secondary})`,
      secondaryInverse: `var(--slate-color-program-surface-faire_direct-secondary-inverse, ${ProgramFallback.surface.faire_direct.secondaryInverse})`,
      tertiary: `var(--slate-color-program-surface-faire_direct-tertiary, ${ProgramFallback.surface.faire_direct.tertiary})`,
    },
  },
  text: {
    insider: `var(--slate-color-program-text-insider, ${ProgramFallback.text.insider})`,
    top_shop: `var(--slate-color-program-text-top_shop, ${ProgramFallback.text.top_shop})`,
    faire_source: `var(--slate-color-program-text-faire_source, ${ProgramFallback.text.faire_source})`,
    faire_pay: `var(--slate-color-program-text-faire_pay, ${ProgramFallback.text.faire_pay})`,
  },
  icon: {
    insider: `var(--slate-color-program-icon-insider, ${ProgramFallback.icon.insider})`,
    top_shop: `var(--slate-color-program-icon-top_shop, ${ProgramFallback.icon.top_shop})`,
    faire_source: `var(--slate-color-program-icon-faire_source, ${ProgramFallback.icon.faire_source})`,
    market: `var(--slate-color-program-icon-market, ${ProgramFallback.icon.market})`,
    faire_pay: `var(--slate-color-program-icon-faire_pay, ${ProgramFallback.icon.faire_pay})`,
  },
  border: {
    ai_suggestions: `var(--slate-color-program-border-ai_suggestions, ${ProgramFallback.border.ai_suggestions})`,
  },
} as const;

export const Button = {
  surface: {
    secondary: `var(--slate-color-button-surface-secondary, ${ButtonFallback.surface.secondary})`,
    secondaryHover: `var(--slate-color-button-surface-secondary-hover, ${ButtonFallback.surface.secondaryHover})`,
    secondaryActive: `var(--slate-color-button-surface-secondary-active, ${ButtonFallback.surface.secondaryActive})`,
    tertiary: `var(--slate-color-button-surface-tertiary, ${ButtonFallback.surface.tertiary})`,
    tertiaryHover: `var(--slate-color-button-surface-tertiary-hover, ${ButtonFallback.surface.tertiaryHover})`,
    tertiaryActive: `var(--slate-color-button-surface-tertiary-active, ${ButtonFallback.surface.tertiaryActive})`,
  },
  border: {
    secondary: `var(--slate-color-button-border-secondary, ${ButtonFallback.border.secondary})`,
    secondaryHover: `var(--slate-color-button-border-secondary-hover, ${ButtonFallback.border.secondaryHover})`,
    secondaryActive: `var(--slate-color-button-border-secondary-active, ${ButtonFallback.border.secondaryActive})`,
  },
} as const;

export const Tag = {
  surface: {
    default: `var(--slate-color-tag-surface-default, ${TagFallback.surface.default})`,
    hover: `var(--slate-color-tag-surface-hover, ${TagFallback.surface.hover})`,
    active: `var(--slate-color-tag-surface-active, ${TagFallback.surface.active})`,
    strong: `var(--slate-color-tag-surface-strong, ${TagFallback.surface.strong})`,
  },
} as const;

export const Toggle = {
  surface: {
    default: `var(--slate-color-toggle-surface-default, ${ToggleFallback.surface.default})`,
    inverse: `var(--slate-color-toggle-surface-inverse, ${ToggleFallback.surface.inverse})`,
    subdued: `var(--slate-color-toggle-surface-subdued, ${ToggleFallback.surface.subdued})`,
    disabled: `var(--slate-color-toggle-surface-disabled, ${ToggleFallback.surface.disabled})`,
  },
  border: {
    disabled: `var(--slate-color-toggle-border-disabled, ${ToggleFallback.border.disabled})`,
  },
} as const;

export const ProgressBar = {
  surface: {
    default: `var(--slate-color-progress-bar-surface-default, ${ProgressBarFallback.surface.default})`,
  },
} as const;

export default {
  Action,
  Button,
  Core,
  Expressive,
  Message,
  ProgressBar,
  Program,
  Tag,
  Toggle,
} as const;
